import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Copil, CopilUpdate } from './copii.interface';
import { catchError, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CopiiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getCopilUrl = this.basePath + environment.interop.dgaspc.activitati.copii.getCopil;
    private getCopiiUrl = this.basePath + environment.interop.dgaspc.activitati.copii.getCopii;
    private storeCopilUrl = this.basePath + environment.interop.dgaspc.activitati.copii.storeCopil;
    private updateCopilUrl = this.basePath + environment.interop.dgaspc.activitati.copii.updateCopil;
    private deleteCopilUrl = this.basePath + environment.interop.dgaspc.activitati.copii.deleteCopil;

    constructor(private http: HttpClient) { }

    getCopil(id: number) {
        return this.http.get(this.getCopilUrl + id);
    }

    addCopil(copil: Copil) {
        return this.http.post(this.storeCopilUrl, copil);
    }

    updateCopil(copil: CopilUpdate) {
        return this.http.put(this.updateCopilUrl, copil);
    }

    deleteCopil(id: number) {
        return this.http.delete(this.deleteCopilUrl + id);
    }

    getCopii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(this.getCopiiUrl)
            .pipe(
                map((response) =>
                    response.data.map((copil) => ({
                        id: copil.id,
                        name: copil.full_name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error fetching copii:', error);
                    throw error;
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
